module.exports = __webpack_public_path__ + "img/ic-arrow2.c66e1646.svg";